import '../styles/FAQ.css';

const FAQ = () => {
    return (
        <div className="faq">
            <h2>Curious, aren’t you?</h2>
            <div className="grid">
                <div>
                    <h3>Can I book tickets online?</h3>
                    <p>Absolutely, adventurer! In fact, we’d recommend it. With online booking, you can skip the queue and jump right into your journey through time. Make sure to keep those confirmation emails handy!</p>
                </div>
                <div>
                    <h3>What is the best time to visit?</h3>
                    <p>The ethereal charm of the Edakkal Caves rings loudest between December and May. Ditch the monsoons - nature’s fury is better watched from a distance.</p>
                </div>
                <div>
                    <h3>What should I bring along?</h3>
                    <p>Light clothes, comfortable shoes, and an insatiable sense of curiosity! Also note that these caves offer no space for boredom, so leave that out of your bag.</p>
                </div>
                <div>
                    <h3>Are guided tours available?</h3>
                    <p>Of course! Our experienced local guides are happy to share their knowledge and passion. Let them guide you through these ancient tapestries of rocky artistry.</p>
                </div>
            </div>
        </div>
    );
}

export default FAQ;